import { render, staticRenderFns } from "./Modal_data_blockchain.vue?vue&type=template&id=6c68b73e&"
import script from "./Modal_data_blockchain.vue?vue&type=script&lang=js&"
export * from "./Modal_data_blockchain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports